// import SuccessImage from "../../../Assets/Success.png";
import FliplynLogo from "../Assets/logo/logo.svg"; // <-- Import your logo

import "./OrderSuccess.css";

export default function OrderSuccess() {

  // Auto redirect to /user after 5 secondsbh 
  return (
    <div className="os-page">
      {/* Header */}
    

      <main className="os-container">

        {/* Card */}
        <div className="os-card">
          {/* <div className="os-image-wrapper">
            <img src={SuccessImage} alt="Success" className="os-success-img" />
          </div> */}
                <div className="success-icon">
          <svg
            viewBox="0 0 52 52"
            className="checkmark"
          >
            <circle
              className="checkmark-circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              className="checkmark-check"
              fill="none"
              d="M14 27l7 7 17-17"
            />
          </svg>
        </div>

          <h1 className="os-title">Yay! Order Successful</h1>
          <p className="os-subtext">Your Order is being prepared.</p>
        </div>

        {/* Home Button */}
        <button
          className="os-home-btn"
          onClick={() => (window.location.href = "/user")}
        >
          Home
        </button>

      </main>

      {/* Powered By Section */}
      <div className="os-powered">
        <span>Powered by</span>
        <img src={FliplynLogo} alt="Fliplyn Logo" className="os-powered-logo" />
      </div>

    </div>
  );
}